import { render, staticRenderFns } from "./Report.vue?vue&type=template&id=055268b2&scoped=true"
import script from "@/views/Groups/Tabs/Report.ts?vue&type=script&lang=ts&external"
export * from "@/views/Groups/Tabs/Report.ts?vue&type=script&lang=ts&external"
import style0 from "@/views/Groups/Tabs/report.scss?vue&type=style&index=0&id=055268b2&prod&lang=scss&scoped=true&external"
import style1 from "./Report.vue?vue&type=style&index=1&id=055268b2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "055268b2",
  null
  
)

export default component.exports